import { compact } from 'lodash';

import { createTranslatedText } from '@dreryk/react-common';
import { Heading, Text } from '@dreryk/react-components';

import { appointmentDateFormatter } from './PatientInformationView.utils';

type PatientInformationViewProps = {
   readonly beginDate: Date;
   readonly endDate: Date;
   readonly patientFirstName: string | null;
   readonly patientLastName: string | null;
};

export const PatientInformationView = (props: PatientInformationViewProps): JSX.Element => {
   const patientFullName = createTranslatedText(compact([props.patientFirstName, props.patientLastName]).join(' '));

   return (
      <div>
         <Heading type={'h2'} bold testId={'patientFullName'} content={patientFullName} margin={'0px'} />
         <Text testId={'appointmentDate'}>{appointmentDateFormatter(props.beginDate, props.endDate)}</Text>
      </div>
   );
};
